module.exports = __webpack_public_path__ + "img/contact.b1aa3c41.png";